import isDisabled from './isDisabled';
export default function isEnabled(config) {
  return !isDisabled(config);
}